// extracted by mini-css-extract-plugin
export default {"copy-to-clipboard":"CopyToClipboard_copy-to-clipboard__psfAd"};